import React, {useEffect} from "react";
import './css/buscador.css';
const Ayudaboton = () => {
    let var_ingles = "es";
        if (window.location.href.indexOf("en.") > -1) {
            var_ingles = "en"
        }
        function agregarLibreriasJS(url) {
            const externalScript = document.createElement("script");
            externalScript.id = "external";
            externalScript.async = true;
            externalScript.type = "text/javascript";
            externalScript.src = url;
            document.head.appendChild(externalScript);
        }
    useEffect(() => {
        //agregarLibreriasJS('/componentes/biinegi/dibujaCuadros.min.js');
        if (var_ingles === "es"){
            document.title= "Buscador Sitio INEGI"
        }
        else{
            document.title= "Search Engine INEGI"
        }
        
    },[]);
     
    return(
    <div className="col-md-12 col-sm-12 col-12" style={{display:"inline-flex", flexDirection:"column-reverse"}}>
        <a className="col align-self-end" id="url_ayuda" href="/app/buscador/preguntasf.html" style={{display:var_ingles== "es"?"block":"none", width:"1%"}}  target="_blank">
        <span id="inegi_ayuda" className="inegi-preguntas" style={{cursor:'pointer'}}></span>
        </a>
    </div>
    )
}
export default Ayudaboton;